import { useState } from 'react';
import { useFeature } from '~/modules/root/hook/use-feature';

/**
 * Whether an auth surface draws the revamped two-pane design, decided when the
 * surface mounts and held for as long as it stays on screen.
 *
 * `revamp_2026` is resolved per visitor, so the member someone becomes can have
 * it on where the guest they were a moment ago had it off. The flip lands in
 * the revalidation that reports the new session — the same render the login
 * form is waiting for, because its success effect is gated on the session
 * becoming `Me`. A surface reading the flag live is swapped for the other
 * implementation in that render, which unmounts the form before the effect
 * runs: no post-auth redirect, no `onSuccess` to close the host, and a fresh
 * "Create a free account" left standing over a page the reader has just
 * signed in to.
 *
 * The decision is made again every time a surface mounts, so a reader whose
 * flag has turned on still gets the revamp on the next one they open.
 */
export const useRevampedAuthSurface = (): boolean => {
    const enabled = useFeature('revamp_2026');
    const [pinned] = useState(enabled);

    return pinned;
};
